import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQItem = ({ question, answer, isOpen, toggleOpen }) => (
  <div className="faq-item">
    <div className="faq-question" onClick={toggleOpen}>
      {question}
      <span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span>
    </div>
    {isOpen && <div className="faq-answer">{answer}</div>}
  </div>
);

const FAQs = () => {
  const { t } = useTranslation();
  const totalFAQs = 12;
  const faqs = Array.from({ length: totalFAQs }, (_, i) => ({
    question: t(`faq_questions.${i}`),
    answer: t(`faq_answers.${i}`)
  }));

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <h1>{t('frequently_asked_questions')}</h1>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            question={t(faq.question)}
            answer={t(faq.answer)}
            isOpen={openIndex === index}
            toggleOpen={() => toggleFAQ(index)}
          />
        ))}
      </div>

      <style jsx>{`
        .faq-page {
          background-color: #1a1a1a;
          color: #ffffff;
          min-height: 100vh;
          padding: 20px;
          font-family: Arial, sans-serif;
        }

        h1 {
          text-align: center;
          margin-bottom: 20px;
        }

        .faq-list {
          max-width: 800px;
          margin: 0 auto;
        }

        .faq-item {
          margin-bottom: 10px;
        }

        .faq-question {
          padding: 15px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: bold;
          background: #252525;
          border-radius: 8px;
        }

        .arrow {
          transition: transform 0.3s ease;
        }

        .arrow.open {
          transform: rotate(180deg);
        }

        .faq-answer {
          padding: 15px;
          background-color: #252525;
          line-height: 1.6;
          border-radius: 8px;
        }
      `}</style>
    </div>
  );
};

export default FAQs;